module.exports = "<pre><code class=\"hljs html\"><span class=hljs-tag>&lt;<span class=hljs-name>wv-off-canvas</span> <span class=hljs-attr>ref</span>=<span class=hljs-string>\"my-off-canvas\"</span>&gt;</span>\n  <span class=hljs-comment>&lt;!-- off canvas content --&gt;</span>\n<span class=hljs-tag>&lt;/<span class=hljs-name>wv-off-canvas</span>&gt;</span>\n</code></pre>";


/*****************
 ** WEBPACK FOOTER
 ** ./src-docs/app/snippets/usage-guide01.md
 ** module id = 121
 ** module chunks = 1
 **/